export const CLAIM_PROFILE = 'zehitomo/users/CLAIM_PROFILE';

export const LOAD_PRO = 'zehitomo/users/LOAD_PRO';
export const LOAD_PRO_ERROR = 'zehitomo/users/LOAD_PRO_ERROR';
export const LOAD_PRO_SUCCESS = 'zehitomo/users/LOAD_PRO_SUCCESS';
